import React from "react";
import Projects from "./projects/Projects";
import { Row, Col } from "react-bootstrap";
import ProjectCard from "./projects/ProjectCard";
import projects from "../../content/projects";

const WebDevelopmentPage = () => {
  return (
    <Projects header={{ label: "Web Development" }}>
      <p>
        I build full-stack websites & web applications using the NodeJS
        environment and ReactJS library while leveraging the power of various
        NoSQL and SQL databases.
      </p>
      <Row>
        {projects
          .filter((project) => project.type === "Web")
          .map((project, index) => {
            return (
              <Col key={index} xl={4} lg={6} md={6} sm={12}>
                <ProjectCard
                  name={project.name}
                  img={project.img}
                  description={project.description}
                />
              </Col>
            );
          })}
      </Row>
    </Projects>
  );
};

export default WebDevelopmentPage;
